/**
 * In a situation where an error + data are both possibly returned, assert that the data is renderable.
 *
 * For example, a GraphQL operation that produces an error might also return partial data if the user lacks access to only part of the graph. This function asserts whether to render the data or throw in those situations. In the apiHook options, we have to explicitly set `{ errorPolicy: 'all' }`.
 * See https://www.apollographql.com/docs/react/data/error-handling/#graphql-error-policies and https://github.com/KazooHR/kazoo-web/pull/7003 for more information.
 */
export function assertRenderable<TData, TError extends Error>(
  data: TData | undefined,
  error: TError | undefined
): asserts data is TData {
  if (error && !data) {
    throw error;
  } else if (!data) {
    throw new Error("Data returned null but no error was returned.");
  }
}
